import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import layoutLanguage from "../../language/layoutLanguage";
import { authAPI } from "../../services/api";

function MobileLayout() {

  const location = useLocation();
  const currentPath = location.pathname;

  const { language } = useLanguage();
  const text = layoutLanguage[language];

  const currentUser = authAPI.getCurrentUser();
  const permissions = currentUser?.permissions;

  const hasPermission = (code) => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.includes(code);
  };

  const hasAnySettingsPermission = () => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.some(p => p.startsWith("SETTINGS."));
  };

  const isActive = (path) => {
    if (path === "/settings") {
      return currentPath.startsWith("/settings");
    }
    return currentPath === path;
  };
  const isReportModuleActive =
    currentPath === "/report" || currentPath === "/bill";

  const activeMobile = "text-primary";
  const inactiveMobile = "text-slate-500 dark:text-slate-400";

  return (
    <>
      <footer className="sticky bottom-0 z-10 bg-white/80 p-2 backdrop-blur-sm dark:bg-slate-900/80">
        <div className="flex justify-around">
          {hasPermission("HOME") && (
            <Link
              to="/"
              className={`flex flex-col items-center gap-1 ${
                isActive("/") ? activeMobile : inactiveMobile
              } font-bold`}
            >
              <i className="fas fa-home text-2xl" />
              <span className="text-xs">{text.navHome}</span>
            </Link>
          )}

          {hasPermission("DASHBOARD") && (
            <Link
              to="/dashboard"
              className={`flex flex-col items-center gap-1 ${
                isActive("/dashboard") ? activeMobile : inactiveMobile
              }`}
            >
              <i className="fas fa-chart-line text-2xl" />
              <span className="text-xs">{text.navDashboard}</span>
            </Link>
          )}

          {(hasPermission("REPORT.REPORT") || hasPermission("REPORT.BILL")) && (
            <Link
              to="/report"
              className={`flex flex-col items-center gap-1 ${
                isReportModuleActive ? activeMobile : inactiveMobile
              }`}
            >
              <i className="fas fa-file-alt text-2xl" />
              <span className="text-xs">{text.navReport}</span>
            </Link>
          )}

          <Link
            to="/settings"
            className={`flex flex-col items-center gap-1 ${
              isActive("/settings") ? activeMobile : inactiveMobile
            }`}
          >
            <i className="fas fa-ellipsis-h text-2xl" />
            <span className="text-xs">{text.navSettings}</span>
          </Link>
        </div>
      </footer>
    </>
  );
}

export default MobileLayout;
